export class StyleEditor {
	static formatToLocalized(value?: number) {
		if (!value) return ''
		const userLocale = Intl.DateTimeFormat().resolvedOptions().locale || 'en-US'

		return new Intl.NumberFormat(userLocale).format(value)
	}
}
